import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/leaflink-companies/$')({
  beforeLoad: ({ params, location }) => {
    const rest = params._splat ? `/${params._splat}` : '';
    throw redirect({ href: `/integrations/leaflink${rest}${location.searchStr}`, replace: true });
  },
});
